/*global $, define*/
define('core/factory/ErrorFactory',[
    'angular'
], function(angular) {
    'use strict';

    angular.module('dnaApp').factory('$exceptionHandler',['$log', '$window','$injector', function ($log, $window,$injector) {

        function _logError(error) {
            try {

                var url = dna.app.basePath + '/secure/logJsError';
                var start = Date.now();

                // Log the JavaScript error to the server.
                // --
                // NOTE: In this demo, the POST URL doesn't
                // exists and will simply return a 404.

                $.ajax({
                    type: "POST",
                    url: url,
                    contentType: "application/json",
                    data: angular.toJson(error)
                }).done(function() {
                    $log.debug('Request:\"' + url + '\", time taken: ' + (Date.now() - start) + ' ms');
                }).fail(function(jqXHR, textStatus) {
                    $log.error('Request:\"' + url + '\", time taken: ' + (Date.now() - start) + ' ms', textStatus);
                });

            } catch ( loggingError ) {

                // For Developers - log the log-failure.
                $log.warn( "Error logging failed" );
                $log.log( loggingError );

            }
        };

        return function (exception, cause) {

            $log.error.apply($log, arguments);
            var logData = { 'route': $window.location.pathname + $window.location.search + $window.location.hash };
            if (exception instanceof Error) {
                if (exception.stack) {
                    logData.exception = (exception.message && exception.stack.indexOf(exception.message) === -1)
                        ? 'Error: ' + exception.message + '\n' + exception.stack
                        : 'Trace: ' + exception.stack;
                } else if (exception.sourceURL) {
                    logData.exception = exception.message + '\n' + exception.sourceURL + ':' + exception.line;
                }
            } else {
                logData.exception = exception;
            }
            if (cause) {
                logData.exception += ";\nCause: " + cause;
            }

            _logError(logData);
        };
    }]);
});

